import { call, put, takeLeading, delay } from 'redux-saga/effects';
import { notificationActions } from '../reducers/notification';
import notification from "../api/notification";

function* notificationDataRequest({ payload }: any): any {
  // yield delay(1000);
  const res = yield call(notification.fetchNotifications, payload);
  if (res.status === 'success') {
    yield put(notificationActions.getNotificationDataResponse(res));
  } else {
    yield put(notificationActions.getNotificationDataFailed());
  }
}

function* removeNotification({ payload }: any): any {
  // yield delay(1000);
  const res = yield call(notification.removeNotification, payload);
  if (res.status === 'success') {
    yield put(notificationActions.removeNotificationResponse(res.data));
  } else {
    yield put(notificationActions.removeNotificationFailed());
  }
}

function* removeAllNotifications({ payload }: any): any {
  // yield delay(1000);
  const res = yield call(notification.removeAllNotifications);
  if (res.status === 'success') {
    yield put(notificationActions.removeAllNotificationsResponse(res.data));
  } else {
    yield put(notificationActions.removeAllNotificationsFailed());
  }
}

function* notificationSaga() {
  yield takeLeading('notification/getNotificationDataRequest', notificationDataRequest);
  yield takeLeading('notification/removeNotificationRequest', removeNotification);
  yield takeLeading('notification/removeAllNotificationsRequest',removeAllNotifications);
}

export default notificationSaga;